<template>
  <div>
    <div class="LeftBox">
      <div>
        <div style="height:40px;background: #54a890;padding-left:20px;">
          <a-icon type="fire" style="fontSize:20px;color:#fff;" />
          <span class="spanData">
            本类热点
          </span>
        </div>
        <a-list v-show="infoType != null" size="large" bordered :data-source="listData">
          <a-list-item slot="renderItem" slot-scope="item">
            <a @click="TextcontentClick(item.id)" style="color:#000"><img :src="dot" style="margin-right:5px;"> {{ item.title | titleFilter(item.title) }}</a>
          </a-list-item>
        </a-list>
        <!-- 供应 -->
        <a-list v-show="SdType != null" size="large" bordered :data-source="SupplyAndDemandData">
          <a-list-item slot="renderItem" slot-scope="item">
            <a @click="SupplyandDemandClick(item.id)" style="color:#000"> {{ item.sdTitle| titleFilter(item.title) }}</a>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </div>
</template>
<script>
import { InfoMainWebHits } from '@/api/main/InfoMainManage'
import dot from '@/assets/icon/dot.png'
import { SupplyAndDemandInfoWebHits } from '@/api/main/SupplyAndDemandManager'
import parmSetting from '@/config/parmSetting'
export default {
  data() {
    return {
      title: '',
      data: '',
      dot: dot,
      infoType: '',
      CType: '',
      orgId: '',
      SdType: '',
      listData: [],
      SupplyAndDemandData: []
    }
  },
  methods: {
    loadData() {
      InfoMainWebHits({ orgId: this.orgId, infoType: this.infoType }).then(res => {
        this.listData = ''
        this.listData = res.data.rows.slice(0, 7)
      })
    },
    SupplyAndDemandMethod() {
      SupplyAndDemandInfoWebHits({ orgId: this.orgId, SdType: this.SdType, CType: this.CType }).then(res => {
        this.SupplyAndDemandData = ''
        this.SupplyAndDemandData = res.data.rows.slice(0, 7)
      })
    },

    TextcontentClick(id) {
     const go = this.$router.resolve({ path: 'Textcontent', query: { id, orgId: this.orgId } })
     window.open(go.href, '_blank')
    },
    SupplyandDemandClick(id) {
      const go = this.$router.resolve({ path: 'SupplyandDemandPage', query: { id, orgId: this.orgId } })
       window.open(go.href, '_blank')
    }
  },
  created() {
    this.key = this.$route.query.key
    this.orgId = this.$route.query.orgId
    const parm = parmSetting.filter(item => item.nc === this.$route.query.nc)
    this.title = parm[0].title
    this.infoType = parm[0].infoType
    this.SdType = parm[0].SdType
    this.CType = parm[0].CType
    // eslint-disable-next-line eqeqeq
    if (this.infoType == null) {
      this.SupplyAndDemandMethod()
    } else {
      this.loadData()
    }
  },
  filters: {
    titleFilter: (val) => {
      if (val.length > 12) {
      return val.slice(0, 12) + '...'
      } else {
      return val
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function(val) {
        const parm = parmSetting.filter(item => item.nc === val.query.nc)
        if (parm && parm.length > 0) {
          this.title = parm[0].title
          this.infoType = parm[0].infoType
          this.SdType = parm[0].SdType
          this.CType = parm[0].CType
        } else {
          alert('失败！,系统出错')
        }
      }
    }
  }
}
</script>
<style scoped>
.spanData {
  font-weight: bold;
  font-size: 16px;
  line-height: 40px;
  color: #fff;
}
.LeftBox {
  float: left;
  width: 25%;
}
/* .agricultural_Services_LeftTop{

    } */

.agricultural_Services_LeftBottom {
  padding: 0;
}
</style>
